var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6632_135139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5312 0H9.99997C8.63644 0 7.53125 1.10321 7.53125 2.46872V13.7656C7.53125 14.2448 8.08087 14.5251 8.46875 14.2343L10.8229 12.4687H17.5312C18.8948 12.4687 20 11.3655 20 10V2.46872C20 1.10519 18.8968 0 17.5312 0V0Z",
    fill: "#EFF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 8.15894H10.6279C10.3043 8.15894 10.042 8.42123 10.042 8.74487C10.042 9.06851 10.3043 9.33081 10.6279 9.33081H13.18C13.5036 9.33081 13.7659 9.06851 13.7659 8.74487C13.7659 8.42123 13.5036 8.15894 13.18 8.15894Z",
    fill: "#3AB4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5313 0H13.7656V12.4687H17.5313C18.895 12.4687 20.0001 11.3657 20.0001 10V2.46872C20.0001 1.10504 18.897 0 17.5313 0Z",
    fill: "#D9E4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.904 3.13794H10.6279C10.3043 3.13794 10.042 3.40039 10.042 3.72388C10.042 4.04752 10.3043 4.30981 10.6279 4.30981H16.904C17.2275 4.30981 17.49 4.04752 17.49 3.72388C17.49 3.40039 17.2277 3.13794 16.904 3.13794Z",
    fill: "#3AB4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.904 5.64844H10.6279C10.3043 5.64844 10.042 5.91074 10.042 6.23438C10.042 6.55786 10.3043 6.82031 10.6279 6.82031H16.904C17.2275 6.82031 17.49 6.55786 17.49 6.23438C17.49 5.91074 17.2277 5.64844 16.904 5.64844Z",
    fill: "#3AB4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4895 3.72363C17.4895 4.04758 17.2274 4.30957 16.9036 4.30957H13.7656V3.1377H16.9036C17.2274 3.1377 17.4895 3.4003 17.4895 3.72363Z",
    fill: "#1D9CFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4895 6.23438C17.4895 6.55771 17.2274 6.82031 16.9036 6.82031H13.7656V5.64844H16.9036C17.2274 5.64844 17.4895 5.91089 17.4895 6.23438Z",
    fill: "#1D9CFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49365 12.1835C6.49365 13.7132 5.25357 14.9533 3.72388 14.9533C2.19418 14.9533 0.954102 13.7132 0.954102 12.1835C0.954102 10.6537 2.19418 9.41357 3.72388 9.41357C5.25357 9.41357 6.49365 10.6537 6.49365 12.1835Z",
    fill: "#FFCFBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49356 12.1835C6.49356 13.7132 5.25333 14.9531 3.72363 14.9531V9.41357C5.25333 9.41357 6.49356 10.6538 6.49356 12.1835Z",
    fill: "#F9BCAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72391 14.9534C1.66733 14.9534 0 16.6207 0 18.6773V19.4141C0 19.7378 0.262299 20.0001 0.585938 20.0001H6.86203C7.18552 20.0001 7.44797 19.7378 7.44797 19.4141V18.6773C7.44797 16.6207 5.78064 14.9534 3.72391 14.9534Z",
    fill: "#FF7579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72379 14.9534C3.72379 14.9534 3.72379 14.9534 3.72363 14.9534V20.0001H6.86176C7.18539 20.0001 7.44769 19.7378 7.44769 19.4141V18.6773C7.44785 16.6207 5.78052 14.9534 3.72379 14.9534Z",
    fill: "#FE4A60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6632_135139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.6e1f4edfea798a4d1aa7c95d04ff77ea.svg";
export { ForwardRef as ReactComponent };